window._gaq = window._gaq || [];
window.gtagDatalayer = window.gtagDatalayer || [];

function gtagHasLoaded() {
    return gtagDatalayer.some( function(item) {return item[0] === 'event' && item[1] === 'page_view' && item[2].send_to.length})
}

function sendAdobeEvent(category, action, label, value){
    var fieldsSeparator = '_';
    
    if (['Outbound Link', 'Validation'].includes(category)){
        return;
    }
    
    var linkId = [category,action,label].join(fieldsSeparator);
    if (value) {
        linkId += fieldsSeparator + value.toString().replaceAll(fieldsSeparator,'/');
    }

    (window.DisneyDataLayer || (window.DisneyDataLayer = [])).push(['trackElement', {
        linkId: linkId
    }]);
}

function queueEvent(action, data) {
    var sendEventInterval;
    
    var checkAndSend = function(){
        if (gtagHasLoaded()) {
            data.send_to = dataLayer.marketingTechnology.googleAnalytics.accountId;
            gtag('event', action, data);
            clearInterval(sendEventInterval);
        }
    };
    
    sendEventInterval = setInterval(checkAndSend, 500);
    checkAndSend();
}

var gtag;
var oldga = {
    version: 'ga',
    initialize: function initialize(trackingID, setDomainName, canonical) {
        _gaq.push(['_setAccount', trackingID]);

        _gaq.push(['_setDomainName', setDomainName]);

        _gaq.push(['_setAllowLinker', true]);

        _gaq.push(['_trackPageview', canonical]);

        (function () {
            var ga = document.createElement('script');
            ga.type = 'text/javascript';
            ga.async = true;
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(ga, s);
        })();
    },
    sendEvent: function sendEvent(category, action, label, value) {
        if (value) {
            _gaq.push(['_trackEvent', category, action, label, value]);
        } else {
            _gaq.push(['_trackEvent', category, action, label]);
        }
    },
    trackTransaction: function(transaction) {
        _gaq.push(["_setCustomVar",1,"Purchase",transaction.holidayType,1]);
        _gaq.push(["_addTrans",
            transaction.bookingReference, // Order ID
            transaction.affiliation,	// Affiliation
            transaction.totalPrice, // Total
            "", // Tax
            "", // Shipping
            "", // City
            "", // State
            "" // Country
        ]);

        _gaq.push(["_addItem"].concat(transaction.item));
        _gaq.push(["_trackTrans"]);
    },
    linkByPost: function(form) {
        _gaq.push(['_linkByPost',form]);
    },
    trackSocial: function(network, action) {
        _gaq.push(['_trackSocial', network, action]);
    }
};
var newga = {
    version: 'gtag',
    initialize: function initialize() {
        gtag = function gtag() {
            return gtagDatalayer.push(arguments);
        };
        gtag('js', new Date());
    },
    sendEvent: function sendEvent(category, action, label, value) {
        var eventData = {
            'event_category': category,
            'event_label': label
        };
        if (value) {
            eventData.value = value;
        }
        sendAdobeEvent(category, action, label, value);
        queueEvent(action, eventData);
    },
    trackTransaction: function(transaction) {
        queueEvent( 'Purchase_dimension', {'Purchase': transaction.holidayType});
        queueEvent('purchase',{
            "transaction_id": transaction.bookingReference,
            "affiliation": transaction.affiliation,
            "value": transaction.totalPrice,
            "currency": transaction.currency,
            "tax": 0,
            "shipping": 0,
            "items": [
                {
                    "id": transaction.item[1],
                    "name": transaction.item[2],
                    "list_name": "Search Results",
                    "category": transaction.item[3],
                    "quantity": 1,
                    "price": transaction.item[4],
                }
            ]
        });
    },
    linkByPost: function(){},
    trackSocial: function(network, label) {
        sendAdobeEvent('Social Share', network, label);
        queueEvent(network, {
            'event_category': 'Social Share',
            'event_label': label
        });
    }
};
var GA = newga;
var cookieRegex = document.cookie.match(/forceGA=(\w+)/);
var cookieValue = cookieRegex && cookieRegex[1] ; 
if (window.location.href.includes('forceGA=oldGA') || cookieValue === 'oldGA') {
    GA = oldga;
} else if (window.location.href.includes('forceGA=newGA') || cookieValue === 'newGA') {
    GA = newga;
}
